import { createAction, props } from '@ngrx/store';

export enum FilterActions {
  FILTER_WEBSHOPS = '[Filter] Filter webshops',
  FILTER_PHOTO_GALLERIES = '[Filter] Filter photo galleries',
}

export const filterWebshops = createAction(FilterActions.FILTER_WEBSHOPS, props<{ payload: string }>());
export const filterPhotoGalleries = createAction(FilterActions.FILTER_PHOTO_GALLERIES, props<{ payload: string }>());
